import { httpApi } from '@api/http.api.ts';
import type { CommonTableRequest } from '@routes/sidebar/admin-center/___shared___/types.ts';
import type {
    CommonRolesRankResponse,
    CommonVesselGroupResponseType,
    CommonVesselGroupType,
} from '@routes/sidebar/admin-center/tenant-client/___pages___/roles/___shared___/types.ts';
import type { EmptyResultsDescription, PaginatedResponse } from '@types';

export type GroupTrainingRequest = CommonTableRequest;
export type GroupTrainingAccessRank = CommonVesselGroupType;

export interface GroupTrainingAccess {
    id: number;
    modifiedById: number;
    modifiedByTenantAlias: string;
    modifiedBy: string;
    version: string | null;
    vesselGroups: CommonVesselGroupType[];
    ranks: GroupTrainingAccessRank[];
}

export interface GroupTrainingAccessUpsertRequest {
    vesselGroupIds: number[];
    rankIds: number[];
}

export type GroupTrainingAccessResponse = PaginatedResponse<GroupTrainingAccess, EmptyResultsDescription>;
export type GroupTrainingAccessVesselGroupsResponse = PaginatedResponse<
    CommonVesselGroupResponseType,
    EmptyResultsDescription
>;
export type GroupTrainingAccessRanksResponse = PaginatedResponse<CommonRolesRankResponse, EmptyResultsDescription>;

const getGroupTrainingAccessBaseUrl = (tenantAlias: string) =>
    `admin-center/tenants/${tenantAlias}/rbac/group-training-access`;

export const getApiGroupTrainingAccess = (
    tenantAlias: string,
    payload: GroupTrainingRequest,
): Promise<GroupTrainingAccessResponse> =>
    httpApi
        .post<GroupTrainingAccessResponse>(`${getGroupTrainingAccessBaseUrl(tenantAlias)}/search`, payload)
        .then(({ data }) => data);

export const createApiGroupTrainingAccess = (
    tenantAlias: string,
    payload: GroupTrainingAccessUpsertRequest,
): Promise<GroupTrainingAccess> =>
    httpApi.post<GroupTrainingAccess>(getGroupTrainingAccessBaseUrl(tenantAlias), payload).then(({ data }) => data);

export const updateApiGroupTrainingAccess = (
    tenantAlias: string,
    accessId: number,
    payload: GroupTrainingAccessUpsertRequest,
): Promise<GroupTrainingAccess> =>
    httpApi
        .put<GroupTrainingAccess>(`${getGroupTrainingAccessBaseUrl(tenantAlias)}/${accessId}`, payload)
        .then(({ data }) => data);

export const deleteApiGroupTrainingAccess = (tenantAlias: string, accessId: number): Promise<any> =>
    httpApi.delete<any>(`${getGroupTrainingAccessBaseUrl(tenantAlias)}/${accessId}`).then(({ data }) => data);

export const getApiGroupTrainingAccessVesselGroups = (
    tenantAlias: string,
    payload: GroupTrainingRequest,
): Promise<GroupTrainingAccessVesselGroupsResponse> =>
    httpApi
        .post<GroupTrainingAccessVesselGroupsResponse>(
            `${getGroupTrainingAccessBaseUrl(tenantAlias)}/vessel-groups/search`,
            payload,
        )
        .then(({ data }) => data);

export const getApiGroupTrainingAccessRanks = (
    tenantAlias: string,
    payload: GroupTrainingRequest,
): Promise<GroupTrainingAccessRanksResponse> =>
    httpApi
        .post<GroupTrainingAccessRanksResponse>(`${getGroupTrainingAccessBaseUrl(tenantAlias)}/ranks/search`, payload)
        .then(({ data }) => data);
